import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader, Loading, Card } from "../components/common";
import { GitBranch } from "lucide-react";

const STAGES = [
  { key: "Governance", n: 1 }, { key: "AI Policy", n: 2 }, { key: "Risk Assessment", n: 3 },
  { key: "Data Governance", n: 4 }, { key: "Security", n: 5 }, { key: "Model Governance", n: 6 },
  { key: "Human Approval", n: 7 }, { key: "Compliance", n: 8 }, { key: "Continuous Monitoring", n: 9 },
];

export default function Lifecycle() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <Loading />;

  const data = STAGES.map((s) => ({ name: s.key, value: (stats.stage_distribution.find((x) => x.name === s.key) || {}).value || 0 }));

  return (
    <div>
      <PageHeader title={t("nav.lifecycle")} subtitle="9-stage AI governance lifecycle — every use case follows this path" summary="Nine stage AI governance lifecycle: governance, policy, risk, data, security, model governance, human approval, compliance and continuous monitoring." />

      <Card title="Lifecycle Distribution" className="mb-6">
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data} margin={{ left: -18 }}><CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" vertical={false} /><XAxis dataKey="name" tick={{ fontSize: 9 }} angle={-25} textAnchor="end" height={80} interval={0} /><YAxis tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="value" radius={[6, 6, 0, 0]} fill="#8A1538" /></BarChart>
        </ResponsiveContainer>
      </Card>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {STAGES.map((s) => {
          const count = (stats.stage_distribution.find((x) => x.name === s.key) || {}).value || 0;
          return (
            <button key={s.key} data-testid={`lc-stage-${s.n}`} onClick={() => nav(`/usecases?lifecycle=${encodeURIComponent(s.key)}`)} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 text-start card-shadow transition-all hover:card-shadow-lg hover:-translate-y-0.5">
              <div className="qatar-gradient grid h-12 w-12 shrink-0 place-items-center rounded-2xl text-lg font-bold font-head text-white">{s.n}</div>
              <div><p className="text-sm font-semibold text-slate-800">{s.key}</p><p className="text-xs text-slate-400">{count} use cases at this stage</p></div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
